import React, { useState } from 'react';
import {
  Box,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Settings as SettingsIcon, Logout as LogoutIcon } from '@mui/icons-material';

interface AccountMenuProps {
  avatarUrl?: string;
  name?: string;
  role?: string;
}

const AccountMenu: React.FC<AccountMenuProps> = ({
  avatarUrl = '',
  name = 'User',
  role = 'Contributor',
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSettings = () => {
    navigate('/settings');
    handleClose();
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <IconButton
        onClick={handleMenu}
        sx={{
          p: 0,
          border: '1px solid rgba(138, 43, 226, 0.2)',
          '&:hover': {
            border: '1px solid rgba(138, 43, 226, 0.4)',
          },
        }}
      >
        <Avatar
          src={avatarUrl}
          sx={{
            width: 40,
            height: 40,
            background: 'rgba(138, 43, 226, 0.2)',
          }}
        />
      </IconButton>
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <Typography variant="subtitle2" sx={{ color: '#fff' }}>
          {name}
        </Typography>
        <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
          {role}
        </Typography>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            background: 'rgba(26, 26, 46, 0.95)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(138, 43, 226, 0.2)',
            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
            mt: 1.5,
            '& .MuiMenuItem-root': {
              color: '#fff',
            },
          },
        }}
      >
        <MenuItem onClick={handleSettings}>
          <SettingsIcon sx={{ mr: 1 }} fontSize="small" />
          Settings
        </MenuItem>
        <Divider sx={{ borderColor: 'rgba(138, 43, 226, 0.2)' }} />
        <MenuItem onClick={handleClose}>
          <LogoutIcon sx={{ mr: 1 }} fontSize="small" />
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default AccountMenu; 